/* istanbul ignore file */
import React from 'react';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { AdTypes } from '@bingads-webui-campaign-react/campaign-onboarding-v2';
import { ProgressiveLoadingBlock } from '@bingads-webui-campaign-react/shell-ui-common';

const getStandardShoppingCampaignWizardAsync = () => import(/* webpackMode: 'eager' */ '@bingads-webui-campaign-react/standard-shopping-wizard')
  .then(({ StandardShoppingCampaignWizard }) => StandardShoppingCampaignWizard);

const getComponent = getComponentAsync =>
  () => getComponentAsync()
    .then(component => ({ default: component }));


const StandardShoppingComponent = (props) => {
  const Component = React.lazy(getComponent(getStandardShoppingCampaignWizardAsync));
  return (
    <React.Suspense fallback={<ProgressiveLoadingBlock />}>
      <Component {...props} />
    </React.Suspense>
  );
};

const getShoppingCampaignCreationWizardComponent = campaignTypeName => props => <StandardShoppingComponent {...props} campaignType={campaignTypeName} />;

export const StyledCampaignCreationSearchShoppingWizard =
  withDefaultStyles(getShoppingCampaignCreationWizardComponent(AdTypes.AudienceAndSearch));
export const StyledCampaignCreationAudienceShoppingWizard =
  withDefaultStyles(getShoppingCampaignCreationWizardComponent(AdTypes.ShoppingAudience));
